import { MarketingNavTypes, NavLink, NavSlice } from '@dtx-company/true-common/src/types/appContent'
import { TPrismicNavHeader, TPrismicNavLink } from './v2/Nav.types'
import { parseInternalLinks } from '@dtx-company/inter-app/src/utils/links'
import { prismicClient } from '@app/prismic/src/utils'

export const fetchMarketingNavData = async (): Promise<MarketingNavTypes> => {
  return prismicClient
    .getSingle('top_nav', {})
    .then(({ data }) =>
      data.body.reduce(
        (
          acc: MarketingNavTypes,
          {
            slice_type,
            items,
            primary
          }: {
            slice_type: 'desktop' | 'mobile'
            primary: TPrismicNavHeader
            items: TPrismicNavLink[]
          }
        ) => {
          const parsedSlice: NavSlice = {
            items: items.map(
              ({
                fullwidth,
                link_title,
                link_subtext,
                dropdown_link,
                isexternal
              }: TPrismicNavLink): NavLink => ({
                fullWidth: fullwidth,
                label: link_title[0]?.text ?? '',
                label_subtext: link_subtext[0]?.text,
                link: dropdown_link.url ? parseInternalLinks(dropdown_link.url) : '',
                isExternal: isexternal
              })
            ),
            columns: primary.columns,
            label: primary.header[0]?.text ?? '',
            link: primary.header_link.url ? parseInternalLinks(primary.header_link.url) : '',
            isDense: primary.isdense,
            isExternal: primary.isexternal
          }
          if (acc[slice_type]) {
            acc[slice_type].push(parsedSlice)
          } else {
            acc[slice_type] = [parsedSlice]
          }
          return acc
        },
        {}
      )
    )
    .catch(e => {
      console.error('Error fetching navigation header data: ', e)
      return {}
    })
}
